import { GetTMDListResponse } from "./TMD.types";

export class TMDApi
{
     /**
     * Fetches the TMDs from the API.
     * @param pageNumber The page number to fetch
     * @param pageSize The number of items per page
     * @param search Optional search term to filter results
     * @returns {Promise<GetTMDListResponse>} A promise that resolves to a GetTMDListResponse object.
     */
    async getTmdListAsync( pageNumber: number = 0, pageSize: number = 10, search?: string ): Promise<GetTMDListResponse>
    {
        let url = `${import.meta.env.VITE_API_URL}/Tmd/list?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if( search )
        {
            // append the search query to the URL if necessary
            url += `&search=${search}`;
        }

        // fetch the TMDs from the public Platform API
        const response = await fetch(url,
        {
            method: 'GET',
            headers:
            {
                'Content-Type': 'application/json',
            }
        });

        return await response.json();
    }
}
